import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import News from './pages/News/News';
import NewsDetail from './pages/News/NewsDetail';
import MainLayout from './layouts/MainLayout';
import Events from './pages/Events/Events';
import MayorDuties from './pages/Mayor/MayorDuties';
import Parks from './pages/Parks/Parks';
import SocialFacilities from './pages/SocialFacilities/SocialFacilities';
import InformationRequest from './pages/InformationRequest/InformationRequest';
import PersonalInformationRequest from './pages/PersonalInformationRequest/PersonalInformationRequest';
import OrganizationChart from './pages/OrganizationChart/OrganizationChart';
import Muhtarliklar from './pages/Muhtarliklar/Muhtarliklar';
import EventsDetail from './pages/Events/EventsDetail';
import Directorates from './pages/Directorates/Directorates';
import DirectoratesDetail from './pages/Directorates/DirectoratesDetail';
import Council from './pages/Council/Council';
import CouncilDetail from './pages/Council/CouncilDetail';
import ReportIncident from './pages/ReportIncident/ReportIncident';
import NotFound from './pages/NotFound/NotFound';
import Pharmacies from './pages/Pharmacies/Pharmacies';
import Announcement from './pages/Announcement/Announcement';
import AnnouncementDetail from './pages/Announcement/AnnouncementDetail';
import Tenders from './pages/Tenders/Tenders';
import TendersDetail from './pages/Tenders/TendersDetail';
import AnnualReports from './pages/AnnualReports/AnnualReports';
import Contact from './pages/Contact/Contact';
import Mayor from './pages/Mayor/Mayor';

import Marriage from './pages/Marriage/Marriage';
import MissionVision from './pages/MissionVision/MissionVision';
import History from './pages/History/History';
import EmergencyPoints from './pages/EmergencyPoints/EmergencyPoints';
import CouncilMembers from './pages/CouncilMembers/CouncilMembers';
import CorporateIdentity from './pages/CorporateIdentity/CorporateIdentity';
import Search from './pages/Search/Search';
import CityMap from './pages/CityMap/CityMap';
import InformationRight from './pages/InformationRight/InformationRight';
import Mobese from './pages/Mobese/Mobese';
import Mahalleler from './pages/Mahalleler/Mahalleler';
import MahalleDetail from './pages/Mahalleler/MahalleDetail';
import SEO from './components/SEO/SEO';
import { getSiteSettings } from './api/siteSettings';
import Advertisement from './pages/Advertisement/Advertisement';
import AdvertisementDetail from './pages/Advertisement/AdvertisementDetail';
import Videos from './pages/Videos/Videos';
import Projects from './pages/Projects/Projects';
import ProjectDetail from './pages/Projects/ProjectDetail';
import KVKK from './pages/KVKK/Kvkk';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import LibraryAppointment from './pages/LibraryAppointment/LibraryAppointment';
import AppointmentCancellation from './pages/AppointmentCancellation/AppointmentCancellation';
import SportsAppointment from './pages/SportsAppointment/SportsAppointment';
import SportsAppointmentCancellation from './pages/SportsAppointment/SportsAppointmentCancellation';
import PaymentSuccess from './pages/SportsAppointment/PaymentSuccess';
import PaymentFail from './pages/SportsAppointment/PaymentFail';
import MobileAccountDeletion from './pages/MobileAccountDeletion/MobileAccountDeletion';
import BaskanlaFotografim from './pages/BaskanlaFotografim/BaskanlaFotografim';
import SocialLinks from './pages/SocialLinks/SocialLinks';
import GarbageServices from './pages/GarbageServices/GarbageServices';
import Okam from './pages/Okam/Okam';


import './styles/main.scss';
import AccessibilityControls from './components/AccessibilityControls/AccessibilityControls';

const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

function App() {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settings = await getSiteSettings();
        setSiteSettings(settings);


        if (settings?.data) {
          const { colorCode1, colorCode2, colorCode3 } = settings.data;


          document.documentElement.style.setProperty('--color-primary', `#${colorCode1}`);
          document.documentElement.style.setProperty('--color-secondary', `#${colorCode2}`);
          document.documentElement.style.setProperty('--color-accent', `#${colorCode3}`);
        }
      } catch (error) {
        console.error('Site ayarları yüklenirken hata oluştu:', error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <Router>
      <SEO />
      <AccessibilityControls />
      <Routes>
        <Route
          path="/e-odeme"
          element={<ExternalRedirect to="https://webportal.iskenderun.bel.tr/engine/saysis.php?szbrtys=agfmCA" />}
        />
        <Route
          path="/"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/iletisim"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Contact />
            </MainLayout>
          }
        />
        <Route
          path="/temizlik-hizmetleri"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <GarbageServices />
            </MainLayout>
          }
        />
        <Route
          path="/kvkk-basvuru"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <KVKK />
            </MainLayout>
          }
        />
        <Route
          path="/gizlilik-politikasi"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <PrivacyPolicy />
            </MainLayout>
          }
        />
        <Route
          path="/haberler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <News />
            </MainLayout>
          }
        />
        <Route
          path="/haberler/:urlTag"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <NewsDetail />
            </MainLayout>
          }
        />

        <Route
          path="/meclis-kararlari"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Council />
            </MainLayout>
          }
        />
        <Route
          path="/meclis-kararlari/:id"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <CouncilDetail />
            </MainLayout>
          }
        />

        <Route
          path="/etkinlikler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Events />
            </MainLayout>
          }
        />
        <Route
          path="/etkinlikler/:urlTag"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <EventsDetail />
            </MainLayout>
          }
        />

        <Route
          path="/ilanlar"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Advertisement />
            </MainLayout>

          }
        />
        <Route
          path="/ilanlar/:urlTag"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <AdvertisementDetail />
            </MainLayout>

          }
        />

        <Route
          path="/faaliyet-raporlari"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <AnnualReports />
            </MainLayout>
          }
        />

        <Route
          path="/mudurlerimiz"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Directorates />
            </MainLayout>
          }
        />
        <Route
          path="/mudurlukler/:slug"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <DirectoratesDetail />
            </MainLayout>
          }
        />

        <Route
          path="/ihaleler"
          element={
            <MainLayout title="İhaleler" customHeader={Header} customFooter={Footer}>
              <Tenders />
            </MainLayout>
          }
        />
        <Route
          path="/ihaleler/:urlTag"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <TendersDetail />
            </MainLayout>
          }
        />

        <Route
          path="/baskan"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Mayor />
            </MainLayout>
          }
        />
        <Route
          path="/baskan-gorev-yetkileri"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <MayorDuties />
            </MainLayout>
          }
        />

        <Route
          path="/nobetci-eczaneler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Pharmacies />
            </MainLayout>
          }
        />
        <Route
          path="/hizmet-rehberi/kuafor-randevu"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <LibraryAppointment />
            </MainLayout>
          }
        />
        <Route
          path="/hizmet-rehberi/kutuphane-randevu"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <LibraryAppointment />
            </MainLayout>
          }
        />
        <Route
          path="/hizmet-rehberi/kutuphane-randevu-iptal"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <AppointmentCancellation />
            </MainLayout>
          }
        />
        <Route
          path="/hizmet-rehberi/spor-randevu"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <SportsAppointment />
            </MainLayout>
          }
        />
        <Route
          path="/spor-randevu/odeme-basarili"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <PaymentSuccess />
            </MainLayout>
          }
        />
        <Route
          path="/spor-randevu/odeme-basarisiz"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <PaymentFail />
            </MainLayout>
          }
        />
        <Route
          path="/hizmet-rehberi/spor-randevu-iptal"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <SportsAppointmentCancellation />
            </MainLayout>
          }
        />
        <Route
          path="/mobil-hesap-sil"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <MobileAccountDeletion />
            </MainLayout>
          }
        />
        <Route
          path="/nikah-islemleri"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Marriage />
            </MainLayout>
          }
        />
        <Route
          path="/misyon-vizyon-ve-temel-degerler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <MissionVision />
            </MainLayout>
          }
        />
        <Route
          path="/iskenderun-tarihi"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <History />
            </MainLayout>
          }
        />
        <Route
          path="/afet-acil-toplanma-alanlari"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <EmergencyPoints />
            </MainLayout>
          }
        />
        <Route
          path="bilgiedinmekurum"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <InformationRequest />
            </MainLayout>
          }
        />
        <Route
          path="bilgiedinmesahis"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <PersonalInformationRequest />
            </MainLayout>
          }
        />
        <Route
          path="/meclis-uyeleri"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <CouncilMembers />
            </MainLayout>
          }
        />
        <Route
          path="/bize-bildir"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <ReportIncident />
            </MainLayout>
          }
        />
        <Route
          path="/kurumsal-kimlik"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <CorporateIdentity />
            </MainLayout>
          }
        />
        <Route
          path="/muhtarliklar"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Muhtarliklar />
            </MainLayout>
          }
        />

        <Route
          path="/organizasyon-semasi"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <OrganizationChart />
            </MainLayout>
          }
        />

        <Route
          path="/parklar"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Parks />
            </MainLayout>
          }
        />
        <Route
          path="/sosyal-tesisler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <SocialFacilities />
            </MainLayout>
          }
        />

        <Route
          path="/duyurular"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Announcement />
            </MainLayout>
          }
        />

        <Route
          path="/duyurular/:urlTag"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <AnnouncementDetail />
            </MainLayout>
          }
        />

        <Route
          path="/iskenderun-sehir-haritasi"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <CityMap />
            </MainLayout>
          }
        />

        <Route
          path="/arama"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Search />
            </MainLayout>
          }
        />

        <Route
          path="/mobese-hizmetleri"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Mobese />
            </MainLayout>
          }
        />

        <Route
          path="/bilgi-edinme-hakki"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <InformationRight />
            </MainLayout>
          }
        />

        <Route
          path="/mahalleler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Mahalleler />
            </MainLayout>
          }
        />
        <Route
          path="/mahalleler/:urlTag"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <MahalleDetail />
            </MainLayout>
          }
        />

        <Route
          path="/aile-koyu-kameralari"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Okam />
            </MainLayout>
          }
        />
        <Route
          path="/okam"
          element={<Navigate to="/aile-koyu-kameralari" replace />}
        />

        <Route
          path="/sosyal-tesisler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <SocialFacilities />
            </MainLayout>
          }
        />

        <Route
          path="/meclis-kararlari"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Council />
            </MainLayout>
          }
        />

        <Route
          path="/meclis-kararlari/*"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <CouncilDetail />
            </MainLayout>
          }
        />

        <Route
          path="/videolar"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Videos />
            </MainLayout>
          }
        />

        <Route
          path="/projeler"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <Projects />
            </MainLayout>
          }
        />

        <Route
          path="/projeler/:slug"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <ProjectDetail />
            </MainLayout>
          }
        />

        <Route
          path="/baskanla-fotografim"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <BaskanlaFotografim />
            </MainLayout>
          }
        />

        <Route
          path="/sosyal-medya"
          element={
            <SocialLinks />
          }
        />

        <Route
          path="*"
          element={
            <MainLayout customHeader={Header} customFooter={Footer}>
              <NotFound />
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
